import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { QuotedPost } from "./QuotedPost";
import { PostType } from "@/types/post";

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
}

interface QuoteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onQuote: () => void;
  name: string;
  username: string;
  content?: string;
  quoteContent: string;
  onQuoteContentChange: (content: string) => void;
  originalPost: PostType;
}

export function DeleteModal({ isOpen, onClose, onDelete }: DeleteModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Post</DialogTitle>
        </DialogHeader>
        <p className="mb-6">
          Are you sure you want to delete this post? This action cannot be
          undone.
        </p>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onDelete}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function QuoteModal({ 
  isOpen, 
  onClose, 
  onQuote,
  name,
  username,
  content = "",
  quoteContent,
  onQuoteContentChange,
  originalPost,
}: QuoteModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Quote Post</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <textarea
            className="w-full min-h-[100px] p-4 resize-none focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Add your comment..."
            value={quoteContent}
            onChange={(e) => onQuoteContentChange(e?.target?.value)}
          />
          <div className="p-4">
            <QuotedPost
              post={originalPost}
              originalPostId={originalPost.id}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={onQuote}>
            Quote
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}